import styled from "styled-components";

const Button = styled.a`
  background: #2d53fe;
  border: 1px solid #2d53fe;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 14px;
  color: #fff;
  transition: all 200ms ease-in-out !important;
  text-decoration: none;
  margin-left: 10px;

  &:hover {
    background: #294be2;
    border-color: #294be2;
  }
`;

export default Button;